<script>
export default {
    props: {
        onClick: Function,
        classes: String,
        value: String
    },
};
</script>

<template>
    <ul
        class="nav nav-pills justify-content-end mt-3 mt-sm-0"
        :class="classes"
    >
        <li class="nav-item">
            <a
                class="nav-link"
                href="Javascript:void(0);"
                :class="{ active: value === 'list' }"
                @click="onClick('list')"
            >
                <i class="bx bx-list-ul"></i>
            </a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                href="Javascript:void(0);"
                :class="{ active: value === 'grid' }"
                @click="onClick('grid')"
            >
                <i class="bx bx-grid-alt"></i>
            </a>
        </li>
    </ul>
</template>
